import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-view" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Administrator ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitTitle = _resolveComponent("MrUiKitTitle")!
  const _component_PersonalData = _resolveComponent("PersonalData")!
  const _component_MrUiKitTab = _resolveComponent("MrUiKitTab")!
  const _component_ProfileManaged = _resolveComponent("ProfileManaged")!
  const _component_ManageMetadata = _resolveComponent("ManageMetadata")!
  const _component_FederationList = _resolveComponent("FederationList")!
  const _component_InternationalCompetition = _resolveComponent("InternationalCompetition")!
  const _component_VisitorList = _resolveComponent("VisitorList")!
  const _component_MrUiKitSideNav = _resolveComponent("MrUiKitSideNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MrUiKitSideNav, {
      collapsed: _ctx.collapse,
      onToggle: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapse = !_ctx.collapse)),
      closeLabel: _ctx.t('common.operations.closeMenu'),
      openLabel: _ctx.t('common.operations.openMenu')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MrUiKitTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('account.details')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_MrUiKitTab, {
          name: _ctx.sideNavLabel.personalDataTitle,
          icon: 'bi bi-person-workspace'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PersonalData, {
              passwords: _ctx.passwords,
              onClick: _ctx.onResetPassword,
              onLogout: _ctx.logout
            }, null, 8, ["passwords", "onClick", "onLogout"])
          ]),
          _: 1
        }, 8, ["name"]),
        (!_ctx.isSuperAdmin && _ctx.isVisitor)
          ? (_openBlock(), _createBlock(_component_MrUiKitTab, {
              key: 0,
              name: _ctx.sideNavLabel.profileManagedTitle,
              icon: 'bi bi-list-ul'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ProfileManaged)
              ]),
              _: 1
            }, 8, ["name"]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock(_component_MrUiKitTitle, { key: 1 }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock(_component_MrUiKitTab, {
              key: 2,
              name: _ctx.sideNavLabel.manageMetadataTitle,
              icon: 'bi bi-journal-plus'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ManageMetadata)
              ]),
              _: 1
            }, 8, ["name"]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock(_component_MrUiKitTab, {
              key: 3,
              name: _ctx.sideNavLabel.tabFederation,
              icon: 'bi bi-list-ul'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FederationList)
              ]),
              _: 1
            }, 8, ["name"]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock(_component_MrUiKitTab, {
              key: 4,
              name: _ctx.sideNavLabel.tabInternationalCompetition,
              icon: 'bi bi-trophy'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InternationalCompetition)
              ]),
              _: 1
            }, 8, ["name"]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock(_component_MrUiKitTitle, { key: 5 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('account.visitors')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock(_component_MrUiKitTab, {
              key: 6,
              name: _ctx.sideNavLabel.tabManagerVisitor,
              icon: 'bi bi-journal-plus'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VisitorList)
              ]),
              _: 1
            }, 8, ["name"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["collapsed", "closeLabel", "openLabel"])
  ]))
}